import PageLoader from './PageLoader'
import SpinnerLoader from './SpinnerLoader'

export default SpinnerLoader

export { PageLoader }
